import ConstantComponent from "../component/ConstantComponent";
import "./InputView.scss";

export default class InputView extends ConstantComponent {
  render() {
    return <input id="terminal-input" type="text" className="grow" />;
  }
}
